import { RequestStatus } from '../../helpers/request'
import { USER_AGREEMENT } from '../action-types'

export default (
    state = {
        draft: {
            requestStatus: RequestStatus.IDLE,
            agreement: null,
        },
        accepted: {
            requestStatus: RequestStatus.IDLE,
            agreement: null,
        },
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        // Draft
        case USER_AGREEMENT.REQUEST_DRAFT:
            return { ...state, draft: { ...state.draft, requestStatus: RequestStatus.PENDING } }

        case USER_AGREEMENT.RECEIVE_DRAFT:
            return {
                ...state,
                draft: { ...state.draft, requestStatus: RequestStatus.RESOLVED, agreement: { ...data } },
            }

        case USER_AGREEMENT.ERROR_DRAFT:
            return { ...state, draft: { ...state.draft, requestStatus: RequestStatus.REJECTED } }

        // Accepted
        case USER_AGREEMENT.REQUEST_ACCEPTED:
            return { ...state, accepted: { ...state.accepted, requestStatus: RequestStatus.PENDING } }

        case USER_AGREEMENT.RECEIVE_ACCEPTED:
            return {
                ...state,
                draft: { ...state.draft, requestStatus: RequestStatus.RESOLVED, agreement: { ...data } },
                accepted: { ...state.accepted, requestStatus: RequestStatus.RESOLVED, agreement: { ...data } },
            }

        case USER_AGREEMENT.ERROR_ACCEPTED:
            return { ...state, accepted: { ...state.accepted, requestStatus: RequestStatus.REJECTED } }

        default:
            return state
    }
}
